<div>

  <div class="section-wallets">
    <div class="container-fluid p-0">
      <div class="row">
        <div class="col-12 col-sm-6 col-md-6 col-lg-4 col-xxl-auto" *ngFor="let wallet of wallets">

          <!-- Existing payment methods -->
          <div class="payment-method" [ngSwitch]="wallet.type">

            <!-- Stripe -->
            <div *ngSwitchCase="'stripe_customer'">
              <div>
                <span class="me-2"><i class="bi bi-credit-card"></i></span>
                <strong>{{ wallet.reference.sources.data[0].brand }}</strong>
              </div>

              <br/>

              <div class="details">
                <div><small>**** **** **** {{ wallet.reference.sources.data[0].last4 }}</small></div>
                <div><small>{{ 'Expires: ' + wallet.reference.sources.data[0].exp_month + '/' + wallet.reference.sources.data[0].exp_year }}</small></div>
              </div>
            </div>

            <!-- Paypal -->
            <div *ngSwitchCase="'braintree_customer'">
              <div>
                <span class="me-2"><i class="bi bi-paypal"></i></span>
                <strong>Paypal</strong>
              </div>

              <br/>

              <div class="details">
                <div><small>{{ wallet.reference.paypalAccounts[0].email }}</small></div>
                <div><small>&nbsp;</small></div>
              </div>
            </div>

            <!-- Invoice -->
            <div *ngSwitchCase="'invoice_customer'">
              <div>
                <span class="me-2"><i class="bi bi-bank"></i></span>
                <strong>Invoice</strong>
              </div>

              <br/>

              <div class="details">
                <div><small>&nbsp;</small></div>
                <div><small>&nbsp;</small></div>
              </div>
            </div>

            <!-- Not implemented -->
            <div *ngSwitchDefault>
              <div>
                <span class="me-2"><i class="bi bi-bank"></i></span>
                <strong>Unknown</strong>
              </div>

              <br/>

              <div class="details">
                <div><small>&nbsp;</small></div>
                <div><small>&nbsp;</small></div>
              </div>
            </div>

            <br/>

            <div>
              <button class="btn btn-sm btn-neon-blue" *ngIf="wallet.isDefault" disabled><strong>Default</strong></button>
              <button class="btn btn-sm btn-white" (click)="setWalletDefault(wallet)" *ngIf="!wallet.isDefault" [disabled]="isWalletDefaultSubmitted">
                <span>Set Default</span>
                <span *ngIf="isWalletDefaultSubmitted" class="spinner-border spinner-border-sm ms-2"></span>
              </button>
            </div>

            <br/>

            <div *ngIf="wallets.length > 1">
              <button class="btn" (click)="removeWallet(wallet)" [disabled]="isWalletRemoveSubmitted">
                <small>Remove</small>
                <span *ngIf="isWalletRemoveSubmitted" class="spinner-border spinner-border-sm ms-2"></span>
              </button>
            </div>
          </div>

          <br/>
        </div>

        <!-- New payment method -->
        <div class="col-12 col-sm-6 col-md-6 col-lg-4 col-xxl-auto">
          <div class="payment-method clickable" (click)="openAddPaymentMethodModal()">
            <div>
              <strong>&nbsp;</strong>
            </div>

            <br/>

            <div class="details">
              <div><small>&nbsp;</small></div>
              <div><small>+ Add payment method</small></div>
            </div>

            <br/>

            <div style="height:44px">&nbsp;</div>
            <br/>
            <div style="height:34px" *ngIf="wallets.length > 1">&nbsp;</div>
          </div>
        </div>

      </div>
    </div>
  </div>

</div>
